import { HighlightActionButton } from './Highlight';
import { withWindow } from '@shared/utils/withWindow';
import { useMediaQuery } from '@withjoy/joykit/utils';
import { useHistory, useRouterHelper } from '@shared/core';
import { useRegistryOverviewTelemetry } from '../../../../telemetry';
import { useRoutePaths } from '@apps/registry/admin/Registry.routes';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useFriendsRegistryRoutePaths } from '@apps/registry/common/components/FriendsRegistry/FriendsRegistry.routes';
import { AFFR_BANNER_INPUT_INPUT_ID, AFFR_BANNER_INPUT_SECTION_ID } from '@apps/registry/common/components/FriendsRegistry/FriendsRegistry.constants';

export const useHighlightController = (onOpen?: () => void, eventId?: string) => {
  const history = useHistory();
  const routes = useRoutePaths();
  const routerHelper = useRouterHelper();
  const { friendsRegistryRoutes } = useFriendsRegistryRoutePaths();
  const { registryOverviewInteraction } = useRegistryOverviewTelemetry();
  const isDesktopScreen = useMediaQuery(theme => theme.mediaQueries.up({ breakpointAlias: 'md' }));
  const isMobileScreen = useMediaQuery(theme => theme.mediaQueries.between(0, { breakpointAlias: 'sm2' }));

  const onButtonClick = useEventCallback(({ variant, component, method, path }: HighlightActionButton) => {
    registryOverviewInteraction({ component, method });
    switch (variant) {
      case 'thankYouDialog':
        onOpen?.();
        return;
      case 'checklist':
        const url = new URL(withWindow(global => global.location.href, ''));
        url.searchParams.append('checklistVisible', 'true');
        history.replace({ search: url.searchParams.toString() });
        return;
      case 'shopLink':
        history.push(routerHelper.buildPath(path ?? routes.shopCatalog.path + path));
        return;
      case 'mobileApp':
        history.push(routes.quickAdd.path);
        return;
      case 'friendsRegistryLink':
        eventId
          ? history.push({
              pathname: routerHelper.buildPath(friendsRegistryRoutes.addToFriendsRegistryIndex.path),
              search: `?scrollto=${AFFR_BANNER_INPUT_SECTION_ID}&focusto=${AFFR_BANNER_INPUT_INPUT_ID}`
            })
          : onOpen?.();
        return;
      case 'quickAddLink':
        history.push(routes.quickAdd.path);
        return;
      default:
        history.push(path ?? routes.shopCatalog.path + path);
        return;
    }
  });

  return {
    isMobileScreen,
    isDesktopScreen,
    onButtonClick
  };
};
